import { createPusherEvent } from '../../pusher';
import { PusherChannel, PusherEventName } from '../../pusher/types';
import { ClassPusherEvent } from '../classes/pusher-events';
import { ToBeDone } from '../types';

export type PollSubmittedEvent = ClassPusherEvent<{
  pollId: MongoId;
  toBeDone: ToBeDone;
  /** key is student id of the student who submitted the poll*/
  submission: Record<MongoId, { optionSelected: number }>;
}>;

export const pollSubmittedEvent = createPusherEvent<PollSubmittedEvent>(PusherEventName.POLL_SUBMITTED, {
  channels: [PusherChannel.COURSE],
});
